import { IconCertified, ProgressBar, useErrorSentryLog } from "materia"
import { useTranslation } from "react-i18next"
import { modifiers } from "ui-tools"
import { Stars } from "../../Stars"
import { UserFilter } from "../UserWidget/UserFilters"

import s from "./UserInfoHeader.module.scss"

export const UserInfoHeaderError = ({
  error,
}: {
  error: unknown | unknown[]
}) => {
  // TODO [sentry-logging] https://jira.attensi.com/browse/WEB-18745
  // Find a better place to send Sentry logs from
  useErrorSentryLog(error)
  const { t } = useTranslation()

  return (
    <div className={s.error}>
      <div className={s.row}>
        <div className={s.stars}>
          <Stars count={1} max={1} size="extraSmall" />
          <div className={s.stars__value}>?/?</div>
        </div>
        <div className={modifiers(s, "completed", { isActive: false })}>
          <IconCertified />
          <div className={s.completed__value}>?</div>
          <div className={s.completed__label}>{t("user.COMPLETED")}</div>
        </div>
        <UserFilter.Error
          text={t("user.MANDATORY")}
          progress="?"
          variant="mandatory"
        />
        <UserFilter.Error
          text={t("user.INCOMPLETE")}
          progress="?"
          variant="incomplete"
        />
      </div>
      <div className={s.progress}>
        <ProgressBar value={0} maxValue={1} />
      </div>
    </div>
  )
}
